<template>
  <el-tooltip
    :content="content"
    :disabled="isShowTooltip"
    :effect="effect"
    :placement="placement"
  >
    <div
      @mouseover="onMouseOver(content)"
      style="overflow: hidden;  text-overflow: ellipsis; white-space: nowrap;"
    >
      <span :class="contentClass" :ref="content">{{content}}</span>
    </div>
  </el-tooltip>
</template>
<script>
/**
 * 用于文字超出时 显示tooltips
 * props content String 展示内容
 * props effect String 主题
 * props placement String 弹出位置
 * props contentClass String 传入class 样式 /deep/生效
*/
export default {
  name: 'ElTooltipOverShow',
  props: {
    content: {
      type: String,
      default: ''
    },
    effect: {
      type: String,
      default: 'dark'
    },
    placement: {
      type: String,
      default: 'top'
    },
    contentClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShowTooltip: false
    }
  },
  methods: {
    onMouseOver(str) { // 内容超出，显示文字提示内容
      const tag = this.$refs[str]
      const parentWidth = tag.parentNode.offsetWidth // 获取元素父级可视宽度
      const contentWidth = tag.offsetWidth // 获取元素可视宽度
      this.isShowTooltip = contentWidth <= parentWidth
    }
  }
}
</script>
